import { AggregateRoot, CommandHandlerFunction } from "@lookiero/messaging";
import { PlayGame } from "../command/playGame";
import { gamePlayed } from "./gamePlayed";

interface Game extends AggregateRoot {
  readonly like: boolean;
  readonly view: string;
}

const playGameHandler: CommandHandlerFunction<PlayGame, Game> =
  () =>
  async ({ aggregateRoot, command }) => {
    const { aggregateId, like, view } = command;

    return {
      ...aggregateRoot,
      like,
      view,
      domainEvents: [gamePlayed({ aggregateId })],
    };
  };

export { playGameHandler };
export type { Game };
